"use strict";

require('../css/default.css');

var ReactTelephoneInput = require('./ReactTelephoneInput');

module.exports = ReactTelephoneInput;